<script setup>
import { useRoute } from '@js/utils/route';

const { server, tenant, callback } = defineProps({
    server: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

function toggleAction() {
    axios
        .post(
            route('front.projectManagement.dev.postRemoveTenantsFromServer', {
                server: server.id,
            }),
            {
                tenantIds: [tenant.id],
            },
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" />
</template>
